// Local Imports
import { Progress } from "components/ui";

// ----------------------------------------------------------------------

export function SplashScreen() {
  return (
    <div className="fixed inset-0 grid h-full w-full place-content-center bg-background">
      <div className="flex flex-col items-center justify-center">
        {/* Styled Logo Text matching Header */}
        <div className="inline-flex items-baseline font-serif select-none">
          {/* Main Text: Original Image-Matched Color */}
          <span className="text-3xl font-black capitalize tracking-tight text-[#2B6CB0] sm:text-4xl dark:text-[#4299E1]">
            <span className="text-4xl sm:text-5xl">R</span>aajneeti
          </span>

          {/* Dynamic AI Badge with Theme Colors */}
          <span className="relative -top-4 ml-2.5 inline-flex items-center justify-center rounded-lg bg-primary-600 px-3 py-1 text-xs font-black uppercase tracking-wider text-white shadow-sm transition-colors duration-200 dark:bg-primary-500">
            AI
          </span>
        </div>

        {/* Progress Bar */}
        <Progress
          color="primary"
          isIndeterminate
          animationDuration="1s"
          className="mt-6 h-1 w-48"
        />
      </div>
    </div>
  );
}